import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL, USER_URL } from "../../constant/api";

function AdminBrandsView() {
const { id } = useParams(); // Get brandId from URL params
  const [brand, setBrand] = useState({}); // Initialize as an object
  // const [brandProducts, setBrandProducts] = useState([]); // Products array
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const navigate = useNavigate();

  // Fetch brand details
  useEffect(() => {
    const fetchBrandDetails = async () => {
      try {
        const response = await USER_URL.get(`/products/admin/brands/${id}/`, );
        console.log(response);
        
        if (response.data && response.data.Data) {
          setBrand(response.data.Data || {}); // Set the brand details
          // setBrandProducts(response.data.Data.products || []); // Set associated products
        }
      } catch (error) {
        console.error("Error fetching brand details:", error.message || error);
      } finally {
        setIsLoading(false); // Set loading to false after API call
      }
    };

    if (id) {
      fetchBrandDetails();
    }
  }, []);

  return (
    <div className="">
      <div className="border-2 rounded-lg shadow-lg bg-gray-50  p-6 ">
        <h2 className="text-green-700 text-3xl font-bold text-center mb-10 mt-5">Brand </h2>

        {isLoading ? (
          <p className="text-center text-gray-500">Loading...</p>
        ) : (
          <>
            {/* Brand Section */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-16 ">
              <div>
                {/* Brand Banner */}
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Brand Banner</h3>
                <div className="relative">
                  {brand?.brand_banner ? (
                    <img
                      src={
                        brand.brand_banner instanceof File
                          ? URL.createObjectURL(brand.brand_banner) // Show selected banner file
                          : `${BASE_URL}${brand.brand_banner}` // Show banner from API
                      }
                      alt={`${brand.brandname || "Brand"} Banner`}
                      className="w-full h-48 object-cover rounded-md mb-4"
                    />
                  ) : (
                    <div className="w-full h-44 bg-gray-100 flex items-center justify-center rounded-md text-gray-500 mb-4">
                      No Banner Available
                    </div>
                  )}
                </div>
              </div>

              {/* Brand Details */}
              <div>
                <div className="p-4 bg-white border rounded-lg shadow-sm mb-10">
                  <span className="block text-sm font-medium text-gray-600 mb-1">Brand Name</span>
                  <p className="text-lg font-semibold text-gray-800">
                    {brand?.brandname || "No Name"}
                  </p>
                </div>
                <div className="p-4 bg-white border rounded-lg shadow-sm mb-4">
                  <span className="block text-sm font-medium text-gray-600 mb-1">Brand Logo</span>
                  {brand?.image ? (
                    <img
                      src={
                        brand.image instanceof File
                          ? URL.createObjectURL(brand.image) // Show selected logo file
                          : `${BASE_URL}${brand.image}` // Show logo from API
                      }
                      alt={`${brand.brandname || "Brand"} Logo`}
                      className="size-24 object-cover rounded-md border border-green-300   p-2 m-2  shadow-slate-400 shadow-md cursor-pointer hover:shadow-2xl transition-all duration-300"
                    />
                  ) : (
                    <div className="w-24 h-24 border border-gray-300 rounded-md p-2 flex items-center justify-center">
                      <span className="text-gray-500 text-sm">No Logo</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Products Section */}
            {/* <div className="mt-6">
              <h4 className="text-xl font-bold mb-4">Products in Brand</h4>
              {brandProducts.length > 0 ? (
                <div className="overflow-x-auto">
                  <table className="w-full text-left border">
                    <thead>
                      <tr>
                        <th className="py-2 px-2 text-green-500 text-sm font-bold">Item No</th>
                        <th className="py-2 px-2 text-green-500 text-sm font-bold">Product Code</th>
                        <th className="py-2 px-2 text-green-500 text-sm font-bold">Product Name</th>
                        <th className="py-2 px-2 text-green-500 text-sm font-bold">Stock</th>
                        <th className="py-2 px-2 text-green-500 text-sm font-bold">Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {brandProducts.map((product, idx) => (
                        <tr key={product.id}>
                          <td className="py-2 px-2 border">{idx + 1}</td>
                          <td className="py-2 px-2 border">{product.code || "N/A"}</td>
                          <td className="py-2 px-2 border">{product.name || "N/A"}</td>
                          <td className="py-2 px-2 border">{product.stock || "N/A"}</td>
                          <td className="py-2 px-2 border">{product.price || "N/A"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-gray-500">No products are available under this brand.</p>
              )}
            </div> */}
          </>
        )}
         {/* Back Button */}
         <div className="mt-4 text-center">
          <button
            onClick={() => navigate(-1)}  // Use navigate(-1) to go back
            className="text-green-600 hover:text-green-700 font-medium text-sm mt-5"
          >
            &lt; Back to Brand List
          </button>
        </div>
      </div>
      
    </div>
  );
}

export default AdminBrandsView